import { Button } from "components/Button";
import { CardWithTitleChip } from "components/CardWithTitleChip";
import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components";
import { CssFlex } from "styles/helpers/layout";

export const StyledModuleCard = styled(CardWithTitleChip)<ThemeProps>`
  width: 21rem;
  min-height: 21rem;
  border-radius: 16px;
`;

export const StyledSubtitle = styled.span<ThemeProps>`
  font-size: ${(props: ThemeProps) => props.theme.font.size._18};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.bold};
`;

export const StyledFooter = styled(CssFlex)`
  border-top: 1px solid ${(props: ThemeProps) => props.theme.palette.neutral._800};
  padding-top: 1rem;
  justify-content: center;
`;

export const StyledInterestedButton = styled(Button)<ThemeProps>`
  border-radius: 8px;
  padding: 0.3rem 1.5rem;
  font-weight: 400;
`;
